import React from "react";

export default () => (<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 200 200"><g fill="#251CA1"><path d="M100 136.9L0 48.1v100.7c0 9 7.4 16.4 16.4 16.4h167.2c9 0 16.4-7.4 16.4-16.4V48.1l-100 88.8z"/><path d="M189 34.9H11l89 78.8z"/></g></svg>)